'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _i18next = require('i18next');

var _i18next2 = _interopRequireDefault(_i18next);

var _i18nextExpressMiddleware = require('i18next-express-middleware');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* i18n client entry-point */

_i18next2.default.use(_i18nextExpressMiddleware.LanguageDetector).init({
  detection: {
    order: ['querystring', 'cookie', 'header'],
    // keys or params to lookup language from
    lookupQuerystring: 'lang',
    lookupCookie: 'i18next',
    // cache user language
    caches: false // ['cookie']
    // optional expire and domain for set cookie
  },
  whitelist: ['en', 'fr', 'ja', 'zh-CN', 'de', 'es', 'it', 'pt'],
  fallbackLng: 'en',

  nsSeparator: '::',
  keySeparator: '##',
  pluralSeparator: '_',
  contextSeparator: '~~',

  // have a common namespace used around the full app
  ns: ['common'],
  defaultNS: 'common',

  interpolation: {
    escapeValue: false // not needed for react!!
  }
});

exports.default = _i18next2.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/i18n-client.js
// module id = 2229
// module chunks = 1